export default {
	signUp: 'Зарегистрироваться',
	password: 'Мы отправим Вам пароль на электронную почту',
	youHaveRegistered: 'Вы успешно зарегистрировались!',
	checkEmail: email => `Мы подублировали Вам на емейл (${email}) параметры для входа`,
	clickOrDrag: 'Нажмите тут или перетащите файлы',
	cleanFiles: 'Очистить файлы',
	update: 'Обновить',
	remove: 'Убрать',
	passportPhoto: 'Фото главного разворота паспорта',
	selfieWithPassport: 'Фото селфи с главным разворотом паспорта',
	extraDocumentPhoto: 'Фото свидетельства ОГРН',
	addressDocumentPhoto: 'Фото страницы регистрации в паспорте',
	rejectedDocuments: 'Ваши документы были отклонены!',
	redirectToUploadDocuments: 'Перейти к загрузке документов'

};
